export { useInteractionTagContext_unstable as useInteractionTagContext } from '@fluentui/react-tags';
export type { InteractionTagContextValue } from '@fluentui/react-tags';
